module.exports = __webpack_public_path__ + "static/banner_b.5ee7f260.png";